import { configureStore } from '@reduxjs/toolkit';
import { activeLocationReducer } from './activeLocationReducer';
import { audioAlertsReducer } from './audioAlertsReducer';
import { avgTimeCashRegisterAllLocationsReducer } from './avgTimeCashRegisterAllLocationsReducer';
import { avgTimeCashRegisterOpenListReducer } from './avgTimeCashRegisterOpenListReducer';
import { compareWithLocationReducer } from './compareWithLocationReducer';
import { dateFilterReducer } from './dateFilterReducer';
import { hourParametersReducer } from './hourParametersReducer';
import { isValidReducer } from './isValidReducer';
import { mostQueueAlertsReducer } from './mostQueueAlertsReducer';
import { queueDurationAllLocationsReducer } from './queueDurationAllLocationsReducer';
import { queueDurationListReducer } from './queueDurationListReducer';
import { totalQueueAlertsReducer } from './totalQueueAlertsReducer';
import { userReducer } from './userReducer';
import { toolbarReducer } from './toolbarReducer';
import { userListReducer } from './userListReducer';
import { selectedUserReducer } from './selectedUserReducer';
import { compareUser1Reducer } from './compareUser1Reducer';
import { compareLocation1Reducer } from './compareLocation1Reducer';
import { compareUser2Reducer } from './compareUser2Reducer';
import { compareLocation2Reducer } from './compareLocation2Reducer';
import { camerasListReducer } from './camerasListReducer';
import { cachedLocationsReducer } from './cachedLocationsReducer';
import { personListReducer } from './personListReducer';
import { selectedCameraReducer } from './selectedCameraReducer';
import { selectedPersonReducer } from './selectedPersonReducer';
import { distinctPersonListReducer } from './distinctPersonListReducer';
import { toolbarDateFilterReducer } from './toolbarDateFilterReducer';
import { toolbarHourFilterReducer } from './toolbarHourFilterReducer';
import { detectionListReducer } from './detectionTypeListReducer';
import { detectionTypesReducer } from './detectionTypesReducer';
import { cameraModelListReducer } from './cameraModelListReducer';
import { detectionServerListReducer } from './detectionServerListReducer';
import { dayWeekMonthYearReducer } from './dayWeekMonthYearReducer';
import { selectedDetectionTypeReducer } from './selectedDetectionTypeReducer';


export const store = configureStore({
  reducer: {
    user: userReducer,
    activeLocation: activeLocationReducer,
    compareWithLocation: compareWithLocationReducer,
    audioAlerts: audioAlertsReducer,
    mostQueueAlerts: mostQueueAlertsReducer,
    dateFilter: dateFilterReducer,
    totalQueueAlerts: totalQueueAlertsReducer,
    hourParameters: hourParametersReducer,
    avgTimeCashRegisterAllLocations: avgTimeCashRegisterAllLocationsReducer,
    queueDurationAllLocations: queueDurationAllLocationsReducer,
    avgTimeCashRegisterOpenList: avgTimeCashRegisterOpenListReducer,
    queueDurationList: queueDurationListReducer,
    isValid: isValidReducer,
    toolbar: toolbarReducer,
    userList: userListReducer,
    distinctPersonList: distinctPersonListReducer,
    selectedUser: selectedUserReducer,
    selectedCamera: selectedCameraReducer,
    selectedDetectionType: selectedDetectionTypeReducer,
    selectedPerson: selectedPersonReducer,
    compareUser1: compareUser1Reducer,
    compareUser2: compareUser2Reducer,
    compareLocation1: compareLocation1Reducer,
    compareLocation2: compareLocation2Reducer,
    toolbarDateFilter: toolbarDateFilterReducer,
    toolbarHourFilter: toolbarHourFilterReducer,
    camerasList: camerasListReducer,
    personList: personListReducer,
    cachedLocations: cachedLocationsReducer,
    detectionList: detectionListReducer,
    detectionTypes: detectionTypesReducer,
    cameraModelList: cameraModelListReducer,
    detectionServerList: detectionServerListReducer,
    dayWeekMonthYear: dayWeekMonthYearReducer
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch